import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type MapAreasInput,
  mapAreasInputSchema,
} from "./shared/alertAreas.input";
import { type Area, areaSchema } from "./shared/alertAreas.output";

/**
 * Metadata for the fetchMapAreas endpoint
 */
export const mapAreasMeta = {
  functionName: "fetchMapAreas",
  endpoint: "/getMapAreasAsJson",
  inputSchema: mapAreasInputSchema,
  outputSchema: areaSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List all available geographic map areas for filtering alerts.",
} satisfies EndpointMeta<MapAreasInput, Area[]>;

const { fetch, useHook } = createFetchAndHook<MapAreasInput, Area[]>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: mapAreasMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/alertAreas.endpoints").alertAreasGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving all available geographic map areas for filtering alerts
 */
export const fetchMapAreas: FetchFactory<MapAreasInput, Area[]> = fetch;

/**
 * React Query hook for retrieving all available geographic map areas for filtering alerts
 */
export const useMapAreas: HookFactory<MapAreasInput, Area[]> = useHook;
